import SxDef from '@core/types/SxDef';

const useSx = (): SxDef => ({
  root: (theme) => ({
    zIndex: 10000,
    pt: 12,
    pb: 4,
    px: 20,
    width: '95%',
    maxWidth: '450px',
    maxHeight:'100vh',

    '&::-webkit-scrollbar': {
      width: '8px',
    },
    '&::-webkit-scrollbar-track': {
      background: '#777',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#555',
      borderRadius: '20px',
    },

    '& img': {
      ml: '-5px',
      height: '40px',
      width: 'auto',
    },

    '& p.MuiTypography-h5': {
      mt: 2,
      fontWeight: 500,
    },

    '& ul': {
      mt: 4,
    },

    [theme.breakpoints.up('xs')]: {
      maxWidth: '450px',
    },
    
  }),
  searchInputContainer: {
    width: '100%',      
    marginTop: '16px',
    marginBottom: '16px',
  },
  
  searchInput: {
    width: '100%',        
    borderRadius: '8px',
  },
  centerCenterSx:{
      minHeight: '100vh',
      width: '100vw',
      overflowY: 'auto',
      display: 'flex',
      alignItems: 'center',
  }
});

export default useSx;
